import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  imports: [NgSwitch, NgSwitchCase, NgSwitchDefault],
  selector: 'app-formly-text',
  template: `
    <ng-container [ngSwitch]="to.htmlTag">
      <h1 *ngSwitchCase="'h1'" [style.color]="to.textColor || 'black'">
        {{ to.label }}
      </h1>
      <h2 *ngSwitchCase="'h2'" [style.color]="to.textColor || 'black'">
        {{ to.label }}
      </h2>
      <h3 *ngSwitchCase="'h3'" [style.color]="to.textColor || 'black'">
        {{ to.label }}
      </h3>
      <h4 *ngSwitchCase="'h4'" [style.color]="to.textColor || 'black'">
        {{ to.label }}
      </h4>
      <h5 *ngSwitchCase="'h5'" [style.color]="to.textColor || 'black'">
        {{ to.label }}
      </h5>
      <h6 *ngSwitchCase="'h6'" [style.color]="to.textColor || 'black'">
        {{ to.label }}
      </h6>
      <p *ngSwitchDefault [style.color]="to.textColor || 'black'">
        {{ to.label }}
      </p>
    </ng-container>

    <ng-container>
      @if (to.hasHr) {
        <hr [style.border]="to.hrBorder || '1px dashed black'" />
      }
    </ng-container>
  `,
})
export class FormlyTextFieldComponent extends FieldType {}
